export const APP_CONST = {
    USER: "kenes_meetingSchedule_user",
    USER_TOKEN: "kenes_meetingSchedule_user_token",
    ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/gif", "image/webp"],
    LOGIN_TOKEN: "kenes_meetingSchedule_login_token"
}